// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oa_a bha_a bha_x","FilterForm__vgroup":"oa_b bha_rp"};